import { render, staticRenderFns } from "./homepageGridButton.vue?vue&type=template&id=16269ee7&scoped=true&"
import script from "./homepageGridButton.vue?vue&type=script&lang=js&"
export * from "./homepageGridButton.vue?vue&type=script&lang=js&"
import style0 from "./homepageGridButton.vue?vue&type=style&index=0&id=16269ee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16269ee7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16269ee7')) {
      api.createRecord('16269ee7', component.options)
    } else {
      api.reload('16269ee7', component.options)
    }
    module.hot.accept("./homepageGridButton.vue?vue&type=template&id=16269ee7&scoped=true&", function () {
      api.rerender('16269ee7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Homepage/homepageGridButton.vue"
export default component.exports